import React from 'react';
import size from 'lodash/size';
import styled from 'styled-components';
import { Audience } from 'src/actions/audiences/audiencesResource';
import { STATUS_SUCCEEDED } from 'src/presentation/hooks/useResource';

import useAudiencesReferences from 'src/presentation/components/pages/audiences/hooks/useAudiencesReferences';
import useIsFeatureEnabled from 'src/presentation/hooks/useIsFeatureEnabled';

export type ReferencesColumnProps = {
  item: Audience;
  resourceType: string;
  roleFeature?: string;
};

const URL_MAPPING = {
  ANSWER: `https://${window.location.host}/kb-admin`,
  HELP_CENTER: 'help-center',
  CHAT: 'chat',
  GLAD_APP: 'chat', // it's here to protect inconsistency with backend version and should be removed in the future
  SIDEKICK: 'chat', // it's here to protect inconsistency with backend version and should be removed in the future
};

const ReferencesColumn = ({ item, resourceType, roleFeature }: ReferencesColumnProps): JSX.Element => {
  const { id } = item;
  const { references, loadingState } = useAudiencesReferences({ item });
  const isFeatureEnabled = useIsFeatureEnabled();
  if (loadingState !== STATUS_SUCCEEDED) {
    return <div>-</div>;
  }
  const count = references && size(references.filter(reference => reference.type === resourceType));
  const hasRole = roleFeature ? isFeatureEnabled(roleFeature) : false;
  const countLink = hasRole ? (
    <ReferenceLink title={count.toString()} data-aid={`referencesLink-${id}`}>
      <a href={`${URL_MAPPING[resourceType]}?audiences=${item.id}`} target="_blank" rel="noreferrer">
        {count.toString()}
      </a>
    </ReferenceLink>
  ) : (
    count.toString()
  );

  return <div>{count ? countLink : 0} </div>;
};

const ReferenceLink = styled.div`
  text-decoration: underline;
`;

export default ReferencesColumn;
